import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const smsChannel = defineChannel({
  id: 'sms',
  icon: 'sms',
  name: 'SMS',
  shortName: 'SMS',
  noun: 'SMS',
  events: [
    'attempted',
    'sent',
    'delivered',
    'deferred',
    'failed',
    'bounced',
    'clicked',
    'converted',
    'drafted',
    'undeliverable',
    'suppressed',
    'replied',
  ],
  deliveryStates: ['attempted', 'sent', 'failed', 'bounced', 'undeliverable', 'delivered', 'holdout', 'suppressed'],
  deliveryActions: ['clicked', 'converted', 'replied'],
} as const satisfies ChannelDefinition);
